// ColorsDialog.js
import { Typography, Button } from '@mui/material'
import "../../css/DemoCode.css"

/**
 * Frame for data inputs. 
 * 
 * @param {JSON} model A SWMM model in JSON format. In most cases this
 * is a 'submodel' containing only a copy of the affected sections. Using a copy allows
 * for continuous react-style editing without forcing the model to run on every keystroke.
 * @param {function} setModel Update function for updating 'model'.
 * @returns UI for interactive swmm modeling.
 */
export default function ColorsDialog({buttonColor, setButtonColor, textColor, setTextColor}) {


  function openTab(evt, tabName) {
    var i, tabcontent, tablinks
  
    // Get all elements with class="tabcontent" and hide them
    tabcontent = document.getElementsByClassName("tabcontent")
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none"
    }
  
    // Get all elements with class="tablinks" and remove the class "active"
    tablinks = document.getElementsByClassName("tablinks")
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", "")
    }
  
    // Show the current tab, and add an "active" class to the button that opened the tab
    document.getElementById(tabName).style.display = "block"
    evt.currentTarget.className += " active"
  }

  /**
   * If there is a valid model, create a UI for the model.
   */
  return(
    <>
    {
      <>
        <Typography id="modal-modal-title" variant="p4" >
          <div style={{display:"flex", flexDirection: "column"}}>
            <label>Colors</label>
          </div>
        </Typography>
        <div style={{background:'black', overflowY: 'hidden'}}>
          {
            <>
            <div className="tab">
              <Button className="tablinks" onClick={(e)=>openTab(e, 'Buttons')}>Buttons</Button>
              <Button className="tablinks" onClick={(e)=>openTab(e, 'Background')}>Background</Button>
              <Button className="tablinks" onClick={(e)=>openTab(e, 'Menus')}>Menus</Button>
              <Button className="tablinks" onClick={(e)=>openTab(e, 'Text')}>Text</Button>
              <Button className="tablinks" onClick={(e)=>openTab(e, 'Symbols')}>Symbols</Button>
            </div>
            
            <div id="Buttons" style={{display: 'block'}} className="tabcontent active">
              {
              <div>
                  <input 
                    type="color" 
                    id="head" 
                    name="head"
                    value={buttonColor} 
                    onChange={e => setButtonColor(e.target.value)} />
                  <label >Buttons</label>
              </div>
              }
            </div>

            <div id="Background" className="tabcontent">
              {<></>}
            </div>

            <div id="Menus" className="tabcontent">
              {<></>}
            </div>

            <div id="Text" className="tabcontent">
            {
            <div>
                <input 
                  type="color" 
                  id="head" 
                  name="head"
                  value={textColor} 
                  onChange={e => setTextColor(e.target.value)} />
                <label >Text</label>
            </div>
            }
            </div>
            
            <div id="Symbols" className="tabcontent">
              
            </div>
            <div className="infocol">
            </div>
            </>
          }
        </div>
        </>
      }
    </>
  )
} 